import Vue from 'vue';
import search from '@/components/button/search';
import clear from '@/components/button/clear';
import add from '@/components/button/add';
import cancel from '@/components/button/cancel';
import pydelete from '@/components/button/pydelete';
import pydeletee from '@/components/button/pydeletee';
import download from '@/components/button/download';
import edit from '@/components/button/edit';
import pyimport from '@/components/button/pyimport';
import sure from '@/components/button/sure';
import more from '@/components/button/more';
import save from '@/components/button/save';
import pyreturn from '@/components/button/pyreturn';
import refresh from '@/components/button/refresh';
import pyexport from '@/components/button/pyexport';
import choose from '@/components/button/choose';
import upload from '@/components/button/upload';
import uploadXCopy from '@/components/button/uploadXCopy';
import close from '@/components/button/close';
import submit from '@/components/button/submit';
import check from '@/components/button/check';
import detail from '@/components/button/detail';
import printing from '@/components/button/printing';
import publish from '@/components/button/publish';
import moveup from '@/components/button/moveup';
import movedown from '@/components/button/movedown';
import see from '@/components/button/see';
import survey from '@/components/button/survey';
import temporarySave from '@/components/button/temporarySave';

import voteImport from '@/components/button/voteImport';
import ban from '@/components/button/ban';
import extend from '@/components/button/extend'; //展开
import back from '@/components/button/back';

import singleUpload from '@/components/button/singleUpload';
import uploadFormForOpen from "@/components/common/uploadFormForOpen";







Vue.component('ps-upload-form', uploadFormForOpen); //查询
Vue.component('ps-search', search); //查询
Vue.component('ps-clear', clear);
Vue.component('ps-add', add);
Vue.component('ps-cancel', cancel);
Vue.component('ps-delete', pydelete);
Vue.component('ps-deletee',pydeletee);//普通删除
Vue.component('ps-download', download); //传入一个文件的Id  只做固定文件   文件路径  不同Id的下载操作
Vue.component('ps-import', pyimport);
Vue.component('ps-edit', edit);
Vue.component('ps-sure', sure);
Vue.component('ps-more', more);
Vue.component('ps-save', save); //保存
Vue.component('ps-return', pyreturn);
Vue.component('ps-refresh', refresh);
Vue.component('ps-export', pyexport);
Vue.component('ps-choose', choose);
Vue.component('ps-pyimport', pyimport);
Vue.component('ps-upload', upload);
Vue.component('xc-upload', uploadXCopy);
Vue.component('ps-close', close); //关闭
Vue.component('ps-submit', submit);
Vue.component('ps-check', check);
Vue.component('ps-detail', detail);
Vue.component('ps-printing', printing);
Vue.component('ps-publish', publish); //发布
Vue.component('ps-moveup', moveup);
Vue.component('ps-movedown', movedown);
Vue.component('ps-see', see);
Vue.component('ps-survey', survey);
Vue.component('ps-back', back);
Vue.component('ps-extend', extend); //展开
Vue.component('ps-ban', ban); //禁用
Vue.component('ps-temporarySave', temporarySave); //暂存

Vue.component('ps-vote-import', voteImport); //投票系统的'导入'

Vue.component('ps-single-upload', singleUpload); //投票系统的'导入'